<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <!-- <v-toolbar-title style="font-size:1rem;">设备信息</v-toolbar-title> -->
      <v-toolbar-title style="font-size:1rem;width:90%;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">设备信息 - {{companyInfo.COMPANY_NAME}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list style="padding:0;">
          <v-list-item @click="goCreateOrder" class="us-list-item">
            <v-list-item-title class="us-list-item-title">
              <i class="fa fa-plus-square" />
              <span>新建报障单</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-content>
      <v-container style="font-size:0.9rem;padding:0;">
        <div v-if="loading" style="margin-top:10rem;"><LoadingText /></div>
        <div v-else>
          <div><DeviceStateCard :dev-info="devInfo" /></div>
          <div v-if="devErrorInfo.length > 0">
            <DeviceErrorMessage :iot-id="iotId" :error-info="devErrorInfo" :server-time="errServerTime" />
          </div>
          <div style="padding:0.9rem 1.1rem 5rem;">
            <div style="position:relative;">
              <div style="position:absolute;left:-0.25rem;top:0;width:4.5rem;height:4.5rem;">
                <DeviceIconImage :dev-info="devInfo" :size="72"  />
              </div>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0;">
                  <!-- 当前状态 -->
                </v-col>
                <v-col :cols="9" style="padding-bottom:0.6rem;">
                  <DeviceStateText :dev-info="devInfo" />
                  <DeviceStateIcon v-if="!devInfo.offLine && devInfo.ACTION_TIME" :normal="normal" />
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  <!-- 设备名称 -->
                </v-col>
                <v-col :cols="9" style="padding-top:0px;padding-bottom: 0px;">
                  {{devInfo.DEV_TEXT}}
                </v-col>
              </v-row>
              <v-row v-if="systemTag">
                <v-col :cols="3" style="color:#9e9e9e;padding:0">
                  <!-- 系统标签 -->
                </v-col>
                <v-col :cols="9" style="padding:0px;">
                  <v-chip class="ma-2" label small outlined style="color:#9E9E9E">
                    {{systemTag}}
                  </v-chip>
                </v-col>
              </v-row>

            </div>

            <div v-if="showMoreProp">
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">接口类型</v-col>
                <v-col :cols="9" style="word-break:break-all;">{{propInfo.pr_interface_type}}</v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">端口</v-col>
                <v-col :cols="9" >{{propInfo.pr_host_port}}</v-col>
              </v-row>
              <!-- <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">Token</v-col>
                <v-col :cols="9" >{{propInfo.pr_token}}</v-col>
              </v-row> -->
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">接收次数</v-col>
                <v-col :cols="9" >
                  <span style="margin-right: 20px;">
                    今天 ( {{ $util.thousandSeparator(statTotal.trigger_count) }} )
                  </span>
                  昨天 ( {{ $util.thousandSeparator(statTotal.yday_trigger_count) }} )
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">心跳次数</v-col>
                <v-col :cols="9" >今天 ( {{ $util.thousandSeparator(statTotal.heartbeat) }} )</v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  检查间隔
                </v-col>
                <v-col :cols="9">
                  {{propInfo.pr_span_time_s}} 秒
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  活跃时间
                </v-col>
                <v-col :cols="9" v-if="activated">
                  <!-- {{$moment(devInfo.ACTION_TIME).format("YYYY-MM-DD HH:mm:ss")}} -->
                  <span style="padding-right:0.3rem;" v-if="devInfoFormatTime">( {{devInfoFormatTime}} )</span>
                  <span>{{$moment(devInfo.ACTION_TIME).format("YYYY-MM-DD HH:mm:ss")}}</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="3" style="color:#9e9e9e;padding-right:0">
                  主机名称
                </v-col>
                <v-col :cols="9">
                  {{devInfo.GW_DEV_TEXT}}
                </v-col>
              </v-row>
            </div>

            <div style="color:#9e9e9e;font-size:0.8rem;text-align:center;margin-top:0.5rem;">
              <span @click="showMoreProp=!showMoreProp">
                <span>查看更多</span>
                <i class="fa fa-angle-down" style="margin-left:0.3rem;color:#9e9e9e;font-size:0.9rem;" aria-hidden="true" v-if="!showMoreProp"></i>
                <i class="fa fa-angle-up" style="margin-left:0.3rem;color:#9e9e9e;font-size:0.9rem;" aria-hidden="true" v-else></i>
              </span>
            </div>
            <v-divider style="margin:1rem 0;" />

            <div v-if="!offLine">


              <v-row>
                <v-row>
                  <v-col :cols="12" >
                    <span style="color:#9e9e9e;margin: 0 12px;">{{ propInfo.pr_value_text ? propInfo.pr_value_text : '合计' }}：</span>
                    <span style="margin-right: 20px;">
                      今天
                      <!-- <span style="font-size: 22px;">{{ formatValue(statTotal.trigger_value) }}</span>
                      <span v-if="unit"> {{ unit }}</span> -->
                      <span style="font-size: 28px;color: #5470c6;">{{ statTotal.format_trigger_value }}</span>
                      <span v-if="unit"> {{ unit }}</span>
                    </span>
                    <span>
                      昨天
                      <!-- <span style="font-size: 22px;">{{ formatValue(statTotal.yday_trigger_value) }}</span>
                      <span v-if="unit"> {{ unit }}</span> -->
                      <span style="font-size: 22px;color: #5470c6;">{{ statTotal.format_yday_trigger_value }}</span>
                      <span v-if="yday_unit"> {{ yday_unit }}</span>
                    </span>
                  </v-col>
                </v-row>
              </v-row>

              <div style="margin-top: 10px;margin-bottom:10px;">
                <!-- <v-row>
                  <v-col :cols="12" style="padding-right:0;font-size:16px;font-weight: 600;">
                    图表
                  </v-col>
                </v-row> -->

              <StatAnyTriggerDaysChart
                id="chart2"
                height="250px"
                :data="triggerDaysInfo"
                :tag-name="propInfo.pr_value_text ? propInfo.pr_value_text : '接收次数'"
                :unit="propInfo.pr_display_rule === 'byte_1024' ? 'MB' : ''" />
              <StatAnyTriggerChart
                id="chart1"
                height="250px"
                :range="range"
                :data="triggerInfo"
                :tag-name="propInfo.pr_value_text ? propInfo.pr_value_text : '接收次数'"
                :unit="propInfo.pr_display_rule === 'byte_1024' ? 'KB' : ''" />
              </div>

            </div>
            <v-divider style="margin:1rem 0;" />
            <div>
              <div style="padding-bottom:0.3rem;color:#9e9e9e;">
                <v-icon color="warning" style="font-size:1.05rem;margin-right:0.3rem;">fa-volume-down</v-icon>告警记录
              </div>
              <AlertHistory :iot-id="iotId" />
            </div>
          </div>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LoadingText from '../../components/LoadingText'
import DeviceStateText from './components/DeviceStateText'
import DeviceIconImage from './components/DeviceIconImage'
import DeviceStateCard from './components/DeviceStateCard'
import AlertHistory from './components/AlertHistory'
import DeviceErrorMessage from './components/DeviceErrorMessage'
import DeviceStateIcon from './components/DeviceStateIcon'
import StatAnyTriggerChart from './components/StatAnyTriggerChart'
import StatAnyTriggerDaysChart from './components/StatAnyTriggerDaysChart'
export default {
  components: {
    LoadingText,
    DeviceStateText,
    DeviceIconImage,
    DeviceStateCard,
    AlertHistory,
    DeviceErrorMessage,
    DeviceStateIcon,
    StatAnyTriggerChart,
    StatAnyTriggerDaysChart
  },
  props: {},
  data() {
    return {
      iotId: '',
      propInfo: {},
      devInfo: {},
      showMoreProp: false,
      companyInfo: {},
      activated: true,
      loading: true,
      onlineHistVis: false,
      normal: false,
      offLine: false,
      devErrorInfo: [],
      systemTag: '',
      tagPrefix: 'yqyw@',
      devInfoFormatTime: '',
      errServerTime: '',
      range: 10,
      echartLoad: false,
      triggerInfo: {},
      statTotal: {
        heartbeat: 0,
        trigger_value: 0,
        trigger_count: 0,
        yday_trigger_value: 0, // yday = Yesterday = 昨天
        yday_trigger_count: 0,
        format_trigger_value: 0,
        format_yday_trigger_value: 0
      },
      unit: '',
      yday_unit: '',
      triggerDaysInfo: {}
    }
  },
  computed: {
  },
  async mounted() {
    var that = this
    that.iotId = that.$route.query.iot_id
    await that.getDevice()
    await that.getDevProp()
    that.loading = false
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    // 获取设备信息
    async getDevice() {
      var that = this
      await that.$api.iot.getDevice({ iot_id: that.iotId }).then(res => {
        // console.log('getDevice.res', res);
        if (!res.success) {
          // that.$toast.warning('获取设备信息失败')
          console.log('获取设备信息失败', res);
          return
        }
        var data = res.data
        that.devInfoFormatTime = that.getDevInfoFormatTime(data.device.ACTION_TIME, res.time)
        that.devInfo = data.device
        that.companyInfo = data.company
        that.activated = that.devInfo.CUR_SID !== '0' && that.devInfo.CUR_SID !== 0
        that.normal = data.normal
        that.getDeviceSystemTags(that.devInfo.DEV_TAGS)
        // 离线退出
        if (data.device.offLine) {
          that.devErrorInfo = []
          that.offLine = true
          return
        }
        that.offLine = false
        that.getDeviceErrorMessage()
      })
    },
    // 获取设备属性
    async getDevProp() {
      var that = this
      var res = await that.$api.iot.getDeviceProp({ iot_id: that.iotId })
      // console.log('getDeviceProp.res', res);
      if (!res.success) {
        // that.$toast.warning('获取设备属性失败')
        console.log('获取设备属性失败', res);
        return
      }
      that.propInfo = res.data
      if (!that.offLine) {
        await that.getTriggerAndHeartbeat()
        await that.getYDayTrigger()
        await that.getAny()
        await that.getDaysTrigger()
      }
    },
    // 获取设备错误信息
    async getDeviceErrorMessage() {
      var that = this
      var res = await that.$api.iot.getDeviceErrorInfo({ iot_id: that.iotId })
      // console.log(res)
      if (!res.success) {
        console.log('获取设备错误信息失败', res)
        return
      }
      that.errServerTime = res.time
      that.devErrorInfo = that.judgeObjectIsNull(res.data) ? [] : res.data.items
    },
    async getAny() {
      var that = this
      var res = await that.$api.iot.submitServiceCmd({ iot_id: that.iotId, method: 'get_tsdb', role: 1, duration: 3,
        item: `{ "format": "values", "range": ${that.range}, "ration": ${that.propInfo.pr_display_rule === 'byte_1024' ? 1024 : 1}, "tags": "trigger" }` })
      // console.log('submitServiceCmd.res', res)
      if (!res.success) {
        // that.$eleUtil.warningMsg(res.error_msg)
        console.log('获取数据失败', res)
        that.echartLoad = true
        return
      }
      that.triggerInfo = res.data
      that.echartLoad = true
    },
    async getTriggerAndHeartbeat() {
      var that = this
      var res = await that.$api.iot.submitServiceCmd({ iot_id: that.iotId, method: 'get_tsdb_total', role: 1, duration: 0,
        item: '{ "tags": "trigger,heartbeat" }' })
      // console.log('submitServiceCmd.res', res)
      if (!res.success) {
        console.log('获取信息失败', res)
        return
      }
      var data = res.data
      if (data && data.items) {
        var heartbeat = data.items.heartbeat
        if (heartbeat) {
          that.statTotal.heartbeat = heartbeat.sum_value
        }

        var trigger = data.items.trigger
        if (trigger) {
          that.statTotal.trigger_value = trigger.sum_value
          that.statTotal.trigger_count = trigger.sum_count
          that.statTotal.format_trigger_value = that.formatValue(trigger.sum_value, true)
        }
      }
    },
    async getYDayTrigger() {
      var that = this
      var res = await that.$api.iot.submitServiceCmd({ iot_id: that.iotId, method: 'get_tsdb_total', role: 1, duration: 1,
        item: '{ "tags": "trigger" }' })
      // console.log('submitServiceCmd.res', res)
      if (!res.success) {
        console.log('获取信息失败', res)
        return
      }
      var data = res.data
      if (data && data.items) {
        var trigger = data.items.trigger
        if (trigger) {
          that.statTotal.yday_trigger_value = trigger.sum_value
          that.statTotal.yday_trigger_count = trigger.sum_count
          that.statTotal.format_yday_trigger_value = that.formatValue(trigger.sum_value, false)
        }
      }
    },
    async getDaysTrigger() {
      var that = this
      var res = await that.$api.iot.submitServiceCmd({ iot_id: that.iotId, method: 'get_tsdb_days', role: 1, duration: 0,
        item: `{ "format": "values", "ration": ${that.propInfo.pr_display_rule === 'byte_1024' ? (1024 * 1024) : 1}, "tags": "trigger" }` })
      // console.log('submitServiceCmd.res', res)
      if (!res.success) {
        // that.$eleUtil.warningMsg(res.error_msg)
        console.log('获取数据失败', res)
        return
      }
      var data = res.data
      that.triggerDaysInfo = data
    },
    // 跳转页面-设备状态历史
    goStateHistory() {
      var that = this
      that.$router.goPage({ path: '/DeviceStateHistory', query: { iot_id: that.iotId }})
    },
    // 判断对象是否为空
    judgeObjectIsNull(v) {
      if (!v) {
        return true
      }
      if (!v.items) {
        return true
      }
      return (JSON.stringify(v) === '{}' || JSON.stringify(v.items) === '{}')
    },
    // 跳转页面-创建报障工单
    goCreateOrder() {
      var that = this
      that.$router.goPage({
        path: '/CreateOrder',
        query:
        {
          title: '[' + that.devInfo.DEV_TEXT + ']异常',
          content: that.$Common.jointContent(that.devErrorInfo)
        }
      })
    },
    getDeviceSystemTags(tags) {
      if (tags === '' || !tags) {
        return []
      }
      var that = this
      var taglist = tags.split(';')
      for (let i = 0; i < taglist.length; i++) {
        if (taglist[i].startsWith(that.tagPrefix)) {
          that.systemTag = taglist[i].replace(that.tagPrefix, '')
          break
        }
      }
      return
    },
    getDevInfoFormatTime(dataTime, nowTime) {
      var that = this
      if (dataTime && nowTime) {
        return that.$moment(dataTime).from(nowTime)
      } else if (dataTime) {
        return that.$moment(dataTime).from()
      } else {
        return ''
      }
    },
    formatValue(v, flag) {
      var that = this
      if (!v) {
        if (that.propInfo.pr_display_rule === 'byte_1024') {
          if (flag) {
            if (that.unit !== 'B') {
              that.unit = 'B'
            }
          } else {
            if (that.yday_unit !== 'B') {
              that.yday_unit = 'B'
            }
          }
          return 0
        }
        if (that.propInfo.pr_unit_name) {
          if (that.unit !== that.propInfo.pr_unit_name) {
            that.unit = that.propInfo.pr_unit_name
          }
          if (that.yday_unit !== that.propInfo.pr_unit_name) {
            that.yday_unit = that.propInfo.pr_unit_name
          }
          return 0
        }
        return 0
      }
      if (that.propInfo.pr_display_rule === 'byte_1024') {
        var d = that.$util.formatByteText(v)
        var arr = d.split(' ')
        if (flag) {
          if (that.unit !== arr[1]) {
            that.unit = arr[1]
          }
        } else {
          if (that.yday_unit !== arr[1]) {
            that.yday_unit = arr[1]
          }
        }
        return arr[0]
        // return that.$util.formatByteText(v)
      }
      if (that.propInfo.pr_unit_name) {
        if (that.unit !== that.propInfo.pr_unit_name) {
          that.unit = that.propInfo.pr_unit_name
        }
        if (that.yday_unit !== that.propInfo.pr_unit_name) {
          that.yday_unit = that.propInfo.pr_unit_name
        }
        return that.$util.thousandSeparator(v)
      }
      return that.$util.thousandSeparator(v)
    }

  }
}
</script>

<style scoped>
</style>
